import clsx from "clsx";
import React from "react";

export default function ProductMatch({product }) {
    const lastUpdate = 'Last Price Update: ' + product.priceUpdateTime;
    return <div
        className={
            clsx(
                "vzp_product plh_item d-flex flex-aligns-center align-items-center me-3 me-lg-5 max-w-200px min-h-80px rounded active bg-white ps-2"
            )
        }
    >
        <a href="#" className="image-input image-input-outline" onClick={(e) => {
            e.preventDefault();
        }}>
            <div
                className={
                    clsx(
                        "image-input-wrapper w-60px h-60px rounded-1",
                        // {'border-gray-200': !isActiveProduct},
                        // {'border-white': isActiveProduct}
                    )
                }
                style={product.img ? {backgroundImage: 'url('+ product.img +')'} : {backgroundColor:product.color}}
            />
        </a>
        <div className="plh_info ms-1 p-2 min-w-150px fw-semibold">
            <a href={product.link} target="_blank" className="fs-6 text-hover-primary fw-bold text-truncate-2lines">
                {product.name}
                {product.brand != undefined ? ' (' + product.brand + ')' : ''}
            </a>
            {
                product.price > 0.1 &&
                <div className="text-gray-500" data-bs-toggle="tooltip" data-bs-placement="top" title={lastUpdate}>
                    <i className="ki-duotone ki-information-5 me-2" >
                        <span className="path1"></span>
                        <span className="path2"></span>
                        <span className="path3"></span>
                    </i>
                    {
                        [product.price, product.currency]
                    }
                </div>
            }
            <a href={product.link} target="_blank" data-bs-toggle="tooltip" data-bs-placement="top" title="View Product">
                View
                <i className="ki-duotone ki-exit-right-corner ms-2">
                    <span className="path1"></span>
                    <span className="path2"></span>
                </i>
            </a>
        </div>
    </div>
}